export var RingTypeEnum;
(function (RingTypeEnum) {
    RingTypeEnum["FullRing"] = "FullRing";
    RingTypeEnum["FullRing58Plus38"] = "FullRing58Plus38";
    RingTypeEnum["OpenAnteriorRing"] = "OpenAnteriorRing";
    RingTypeEnum["OpenMedialRing"] = "OpenMedialRing";
    RingTypeEnum["OpenPosteriorRing"] = "OpenPosteriorRing";
    RingTypeEnum["FootPlate"] = "FootPlate";
})(RingTypeEnum || (RingTypeEnum = {}));
//# sourceMappingURL=RingModel.js.map